import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Button, message, Input, Divider, Tag, Col, Typography } from 'antd';

import { post } from '../utils/httpRequests';
import { APIs } from '../utils/apis';
import { deleteAuthKey } from '../utils/config';

const { TextArea } = Input;
const { Paragraph, Title } = Typography;

const emailPattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

const colors = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue'
];

const DataErasure = () => {
  const [state, setState] = useState({
    emails: '',
    isSubmitting: false
  });

  const onSubmit = () => {
    setState({ ...state, isSubmitting: true });
    const url = APIs.DATA_ERASURE;
    const data = {
      email_ids: state.emails
        .split('\n')
        .map(email => email.trim())
        .splice(0, 10)
        .join(','),
      auth_key: deleteAuthKey
    };

    post({ url, data })
      .then(res => {
        if (res?.data?.meta?.status === 200) {
          message.success('Data Erasure request sent successfully');
        }
        setState({ ...state, isSubmitting: false, emails: '' });
      })
      .catch(err => {
        message.error(err + ': Service error');
        setState({ ...state, isSubmitting: false });
      });
  };

  const RenderEmailTags = () => {
    const { emails } = state;

    let trimmedEmails = emails
      .split('\n')
      .map(email => {
        const temp = email.trim();
        if (temp.length > 0) {
          if (emailPattern.test(temp)) {
            return temp;
          }
          return null;
        }
        return null;
      })
      .filter(email => email !== null);

    const removeEmail = email => {
      trimmedEmails = trimmedEmails.filter(e => e !== email);
      setState({ ...state, emails: trimmedEmails.join('\n') });
    };

    if (trimmedEmails.length > 0) {
      return trimmedEmails.map((email, index) => (
        <Tag
          key={index}
          color={colors[index]}
          closable
          onClose={() => removeEmail(email)}
        >
          {email}
        </Tag>
      ));
    }
    return null;
  };

  return (
    <div>
      <div className="d-flex flex-column">
        <Typography>
          <Title level={3}>User Data Deletion/Erasure</Title>
          <Title level={4}>Note:</Title>
          <Paragraph>
            <ul>
              <li>Enter one email per line without commas</li>
              <li>Max 10 emails per request</li>
              <li>
                If more than 10 emails are entered only the 1st 10 emails will
                be considered
              </li>
              <li>
                It takes approximately 2 hours for each request to complete
              </li>
            </ul>
          </Paragraph>
        </Typography>
        <div className="margin-bottom-10">
          <Divider orientation="left">Emails</Divider>
          <RenderEmailTags />
        </div>
        <div className="margin-bottom-10">
          <TextArea
            value={state.emails}
            onChange={e => setState({ ...state, emails: e.target.value })}
            placeholder="Enter Emails - one email per line - no commas"
            rows={10}
          />
        </div>
        <Col span={24} className="margin-top-10">
          <Button
            type="primary"
            onClick={onSubmit}
            loading={state.isSubmitting}
          >
            Submit
          </Button>
        </Col>
      </div>
    </div>
  );
};

export default withRouter(DataErasure);
